import React, { useContext, useEffect } from "react";
import '../components/FrontProductsBlock.css';
import '../components/Catalog/catpanel.css';
import '../components/catalog.css';
import {observer} from "mobx-react-lite";
import {Context} from "..";
import { getNewCatalog, getProducts, getFavoriteProductsParent} from "../http/productAPI";
// import {getStore, getStores, hasRole} from "../http/userAPI";
import TopBanner from '../components/TopBannerSliders/TopBanner';
import CatPanel from '../components/Catalog/CatPanel';
import FastLinkBar from '../components/FastLinkBar';
import FrontProductsBlock from '../components/FrontProductsBlock';


const Home = observer(() => {

    const {user, product} = useContext(Context)
    const selectedFolderFilters = product.requestBodyFilter;       

   product.setSelectedFolder({ id: "2" });

    useEffect(() => {
        getNewCatalog().then(data => product.setCategories(data))
    }, [product.selectedFolder])

    useEffect(() => {
        getProducts(product.selectedFolder.id, 0, 20, selectedFolderFilters).then(data => product.setProducts(data.products))
    }, [product.search, product.selectedFolder])

    /*useEffect(() => {
          getFavoriteProductsParent(product.selectedFolder.id, product).then(data => {
             const allFavorites = data.flatMap(item => item.favoriteProducts); // 🧠 flatten всех продуктов
             product.setProducts(allFavorites); // 🗃️ сохраняем как обычный список продуктов
           });
       }, [product.selectedFolder])*/

        return (
        <>
            <TopBanner /><CatPanel /><FastLinkBar /><FrontProductsBlock />
        </>
    );
});

export default Home;